const APP_KEY = "paws.updated";
const MODEL_KEY = "paws.model.updated";

export const versionHex = (code) => `0x${Number(code || 0).toString(16).toUpperCase().padStart(4, "0")}`;

const read = (storage, key) => {
  try {
    return JSON.parse(storage?.getItem(key) || "null");
  } catch {
    return null;
  }
};

const write = (storage, key, value) => {
  try {
    storage?.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};

export function trackAppVersion(version, storage = globalThis.localStorage, at = () => new Date().toISOString()) {
  const stored = read(storage, APP_KEY);
  if (stored?.version === version) return stored;
  const entry = { version, at: at() };
  write(storage, APP_KEY, entry);
  return entry;
}

export function trackModelVersion(version, storage = globalThis.localStorage, at = () => new Date().toISOString()) {
  if (!version) return read(storage, MODEL_KEY);
  const stored = read(storage, MODEL_KEY);
  if (stored?.version === version) return stored;
  const entry = { version, at: at() };
  write(storage, MODEL_KEY, entry);
  return entry;
}

export function localDate(iso, locale = "it-IT") {
  if (!iso) return "-";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return String(iso);
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(date);
}

export function buildRows(config, { app, model, metadata }) {
  return [
    ["Versione app", `${config.version} (${config.versionCode})`],
    ["Versione hex", versionHex(config.versionCode)],
    ["App aggiornata su questo dispositivo", localDate(app?.at)],
    ["Modello in uso", metadata?.model_version || "-"],
    ["Modello scaricato su questo dispositivo", localDate(model?.at)],
    ["Modello creato il", localDate(metadata?.created_at)],
    ["Architettura", metadata?.architecture || "-"],
    ["Rilevatore", metadata?.detector ? Object.keys(metadata.detector.variants || {}).join(" · ") || "sì" : "non incluso"]
  ];
}
